// extracted by mini-css-extract-plugin
module.exports = {"Repairy":"Repairy_Repairy__3vI3U"};